import React, { useRef } from 'react';

import { useGenerationProgress } from '../hooks/project/useGenerationProgress';
import type { GenerationPhase } from '../model/generationProgress';

/** Yellow matches the workspace upload button. */
export const GenerationProgressBar: React.FC<{
  status: string;
  phase: GenerationPhase | null;
}> = ({ status, phase }) => {
  const { percent, label, failed } = useGenerationProgress({
    status,
    phase,
  });
  // A project opened after it already failed has nothing to freeze. Only a
  // job we watched move through PENDING gets the red bar.
  const watched = useRef(status === 'PENDING_GENERATION');
  if (status === 'PENDING_GENERATION') {
    watched.current = true;
  }
  if (failed && !watched.current) {
    return null;
  }
  const shown = Math.round(Math.min(100, Math.max(0, percent)));
  const fill = failed ? 'bg-red-500' : 'bg-yellow-400';

  return (
    <div className="w-full max-w-md">
      <div
        className={`
          mb-2 flex items-center justify-between text-sm text-gray-800
        `}
      >
        <span>{failed ? 'Fingering generation failed' : label}</span>
        <span>{shown}%</span>
      </div>
      <div
        className="h-2.5 w-full overflow-hidden rounded-full bg-yellow-100"
        role="progressbar"
        aria-valuenow={shown}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuetext={failed ? 'Fingering generation failed' : label}
      >
        <div
          className={`h-full rounded-full ${fill}`}
          style={{ width: `${shown}%` }}
        />
      </div>
    </div>
  );
};
